<template>
  <v-layout row wrap>
    <!-- <div style="position: absolute;">{{$store.myGetters.missionPlanStagingLoading}} -- {{$store.myGetters.missionPlanConfigLoading}} -- {{$store.myGetters.missionPlanIrisLoading}}</div> -->
    <v-flex xs12 style="position: relative; display: flex; flex-direction: column">
      <v-card class="ma-2" style="flex: 0 0 auto">
        <v-card-title
          class="pb-0"
          style="flex: 1 1 auto; flex-direction: column; align-items: stretch; position: relative; height: 100%"
        >
          <v-layout class="pb-0" row wrap style="flex: 0 0; align-items: flex-start; border-bottom: 1px solid #ccc">
            <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.MissionPlan.Configuration') }}</span>
            <v-spacer />
            <v-switch
              hide-details
              class="pb-2 sm-switch"
              v-model="config.enableMissionPlan"
              @change="saveConfig"
              :label="$t('Pilot.MissionPlan.EnableMissionPlan')"
              style="flex: 0 0 auto"
            />
          </v-layout>
          <v-layout class="pb-0" row wrap style="flex: 0 0; align-items: flex-start">
            <v-layout column>
              <v-subheader class="pa-0">
                <!--<v-slider :disabled="!config.enableMissionPlan" persistent-hint hint="Drift corrected factor" class="mx-2 my-0" :label="`${config.correctedFactor}%`" hide-details thumb-label inverse-label v-model="config.correctedFactor" :min="0" :max="100"  step=1 ></v-slider>-->
                <div class="flex items-center mt-1 mb-2">
                  <v-select
                    :items="[
                      { value: 'trackfollowing', text: $t('Pilot.MissionPlan.Trackfollowing') },
                      { value: 'heading', text: $t('Pilot.MissionPlan.Heading') },
                      { value: 'waypoint', text: $t('Pilot.MissionPlan.Waypoint') },
                    ]"
                    item-text="text"
                    item-value="value"
                    hide-details
                    :label="$t('Simulation.NavigationMode')"
                    v-model="config.mode"
                  ></v-select>
                  <v-spacer />
                  <div class="ml-auto" v-if="config.mode == 'trackfollowing'">
                    <number-field-factor
                      hide-details
                      class="mr-3"
                      v-model.number="config.lookahead"
                      :label="$t('Pilot.MissionPlan.Lookahead')"
                    />
                  </div>
                </div>
              </v-subheader>
            </v-layout>
          </v-layout>
          <v-layout class="pt-0" row wrap style="flex: 0 0; align-items: flex-start">
            <div class="!flex items-center">
              {{ $t('Pilot.MissionPlan.CurrentCorrection') }}
              <v-switch
                :disabled="!config.enableMissionPlan"
                hide-details
                class="pl-2 pb-2 sm-switch"
                v-model="config.enableCorrected"
                :label="$t('Pilot.MissionPlan.EnableCorrected')"
                style="flex: 0 0 auto"
              />
            </div>
            <v-spacer />
            <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>
              {{ $t('Pilot.MissionPlan.RestoreConfig') }}
              <v-icon small right>mdi-replay</v-icon>
            </v-btn>
            <v-btn @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">
              {{ $t('Pilot.MissionPlan.ValidateConfig') }}
              <v-icon small right>mdi-content-save</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-card class="ma-2" style="position: relative; flex: 1 0 auto">
        <v-card-title class="pa-2 maincontent" style="flex-direction: column; align-items: stretch">
          <admin-mission-plan
            :readonly="readonly"
            ref="editPlan"
            :uiid="missionPlanUiid"
            :enablePayload="false"
            @fit="$store.myActions.UI_SELECT_MISSION_MAP({ id: null, uiid: '' })"
            @goto="$store.myActions.UI_SELECT_MISSION_MAP({ id: null, uiid: '' })"
          >
            <template v-slot:action>
              <v-card-actions class="pa-0 px-2 ma-0" :class="{ 'pt-4': readonly }">
                <template v-if="canSimulate">
                  <v-btn :disabled="!isRunnable" @click="runEndMissionSimulation()" small class="grow" color="primary">
                    {{ $t('Simulation.Run') }}
                    <v-progress-circular
                      class="ml-2"
                      :size="20"
                      v-if="!isRunnable"
                      indeterminate
                      color="white"
                    ></v-progress-circular>
                    <v-icon v-else>mdi-play</v-icon>
                  </v-btn>
                  <!-- <v-btn v-else @click="stopSimulation()" small class="" >{{$t('Simulation.Abort')}}<v-progress-circular class="ml-2"  :size="20" v-if="executing" indeterminate color="white"></v-progress-circular><v-icon v-else>mdi-close-octagon-outline</v-icon></v-btn> -->
                </template>
                <v-autocomplete
                  v-if="!readonly"
                  :items="missionPlanTemplates"
                  item-text="libelle"
                  item-value="id"
                  :label="$t('Pilot.MissionPlan.LoadFromTemplate')"
                  v-model="templateId"
                  class="ml-1"
                  :append-outer-icon="templateId ? 'mdi-reload' : ''"
                  @click:append-outer="loadFromTemplate()"
                ></v-autocomplete>
                <v-spacer></v-spacer>
                <v-btn
                  @click="saveAsTemplate()"
                  :title="$t('Pilot.MissionPlan.SaveAsTemaplateTooltip')"
                  small
                  class="ml-1"
                >
                  {{ $t('Pilot.MissionPlan.SaveAsTemaplate') }}
                  <v-icon small right>mdi-content-save</v-icon>
                </v-btn>
                <v-btn :disabled="!showReloadFromIris" @click="reloadFromIris()" small class="ml-1">
                  {{ $t('Pilot.MissionPlan.ReloadFromIris') }}
                  <v-icon small right>mdi-replay</v-icon>
                </v-btn>
                <v-btn
                  v-if="!readonly"
                  :disabled="!showReloadFromIris"
                  @click="saveAndPublishMissionPlan()"
                  small
                  color="primary"
                  class="ml-1"
                >
                  {{ $t('Pilot.MissionPlan.PublishStagingToIris') }}
                  <v-icon small right>mdi-content-save</v-icon>
                </v-btn>
              </v-card-actions>
            </template>
          </admin-mission-plan>
        </v-card-title>
      </v-card>
    </v-flex>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ status }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSaveAsTemplate" persistent width="400">
      <v-card>
        <v-card-title class="bg-primary text-white">{{ $t('Pilot.MissionPlan.SaveAsTemplateTitle') }}</v-card-title>
        <v-card-text>
          <v-text-field hide-details :label="$t('Pilot.MissionPlan.TemplateName')" v-model="template_name" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="showSaveAsTemplate = false">{{ $t('Global.Close') }}</v-btn>
          <v-btn small @click="saveTemplate()" color="primary">
            {{ $t('Global.Save') }}
            <v-icon class="ml-2" small>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import apiAdminMissionVirtual from '@/api/admin/missionVirtual'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { IMissionPlanConfig } from '@/models/iris/missionPlanConfig/IMissionPlanConfig'

import { VuetifyConfirmObject } from 'vuetify-confirm'
import AdminMissionPlan from '@/components/admin/missionPlanTemplate/AdminMissionPlan.vue'
import { AloMissionPlan, IAloMissionPlanConstParam } from '../../models/alo/AloMissionPlan'
import { SecurityItemsKeys } from '../../enum/SecurityItems'
//@ts-ignore
import deepEqual from 'deep-equal'
import { extractDistinctProp } from '../../utils/groupBy'
import { buildMissionPlanStateId, MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
import { cloneDeep } from 'lodash'
import {
  getDefaultSmartSimulation,
  ISmartSimulation,
  isReadyForSimulation,
} from '@/models/iris/smartMission/ISmartSimulation'
import { getDefaultGliderConfig } from '@/models/iris/smartMission/IGliderConfig'
import { SimulationStatus } from '@/enum/SimulationStatus'
import { MissionUiState, buildMissionUIStateId } from '@/models/ui/MissionUiState'
import { CoverageStep } from '@/enum/CoverageStep'
import { CoverageState } from '@/enum/CoverageState'
import {
  AloDbMissionGlobal,
  isAloDbMissionGlobalCoverage,
  isAloDbMissionGlobalSimulation,
  isAloDbMissionGlobalSimulator,
} from '@/models/alodb/AloDbMissionGlobal'
import { AloMission } from '@/models/alo/AloMission'
import { MissionGlobalType } from '@/enum/MissionGlobalType'
import { SIMULATION_SYNC_MISSSIONPLAN_SENSOR } from '@/store/modules/missionGlobal/mutation-types'
import apiAdminMissionGlobal from '@/api/admin/missionGlobal'
import { ApiResultCode } from '@/models/response/AlrBase'

@Component({
  name: 'MissionDetailMissionPlan',
  components: { AdminMissionPlan },
  props: {
    tryClose: {
      type: Boolean,
      default: false,
    },
    isleft: {
      type: Boolean,
      default: false,
    },
    uiid: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mission: AloMission,
  },
})
export default class MissionDetailMissionPlan extends Vue {
  tryClose!: boolean
  isleft!: boolean
  uiid!: string
  executing: boolean = false
  mission!: AloMission
  readonly!: boolean
  showSaveAsTemplate: boolean = false
  template_name: string = ''
  slugify = require('slugify')

  config = {
    enableMissionPlan: false,
    enableCorrected: false,
    enablePayload: false,
    mode: 'heading',
    lookahead: 1,
    //correctedFactor:0
  }

  get filterMission() {
    return this.$store.myGetters.filterMission
  }

  get selectedFilterEnsIds() {
    //@ts-ignore
    return this.filterMission?.ensIds?.at(0) ?? undefined
  }

  get isOperator() {
    return this.$store.myGetters.isOperator
  }

  get isSysAdmin() {
    return this.$store.myGetters.isSysAdmin
  }

  get isRunning() {
    return (
      this.mission &&
      (this.mission.result?.simulation_state == 'running' ||
        ((this.mission.result?.simulation_state?.length ?? 0) == 0 &&
          (this.mission.vimStatus ?? 0) > 0 &&
          this.mission.vimStatus != 10))
    )
  }

  get isRunnable() {
    //si toute les simulations ont un status différent de running
    return !this.isRunning
  }

  get misEnsIds() {
    return this.selectedFilterEnsIds //this.currentDetailMission?.mission?.ensId ?? this.selectedFilterEnsIds
  }

  get missionPlanUiid() {
    return buildMissionPlanStateId(this.mission.misId || -1, 'mission')
  }

  get missionPlanUiState() {
    return this.$store.myGetters.uistatebyuiid(this.missionPlanUiid) as MissionPlanUiState
  }

  get missionDetailUiid() {
    return buildMissionUIStateId(this.mission.misId || -1, 'detail')
  }

  get missionUiState() {
    return this.$store.myGetters.uistatebyuiid(this.missionDetailUiid) as MissionUiState
  }

  get plan() {
    return this.missionPlanUiState.missionPlan
  }
  set plan(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({
      uiid: this.missionPlanUiid,
      plan: value,
    })
  }

  get btnActif() {
    const config = {}
    this.loadConfig(config, this.originalMissionPlanConfig)
    return /*this.config.enableMissionPlan &&*/ !deepEqual(config, this.config) && !this.loading
  }

  templateId = null

  get missionGlobals() {
    return this.$store.myGetters.missionGlobals.filter(
      m =>
        isAloDbMissionGlobalSimulator(m) &&
        ((!this.isOperator && !this.isSysAdmin) || this.misEnsIds == undefined || m.ENS_ID == this.misEnsIds),
    )
  }

  // get missionPlanTemplates() {
  //     return this.$store.myGetters.missionPlanTemplates.filter(mt => (!this.isOperator && !this.isSysAdmin)  || this.misEnsIds == undefined || mt.ENS_ID == this.misEnsIds)
  //   }

  get missionVirtualsById() {
    return this.$store.myGetters.missionVirtualsById
  }

  get endedCoverageIterations() {
    return this.$store.myGetters.coverageIterations.filter(
      ci =>
        ci.COV_PROCESSING_STEP == CoverageStep.FinalSimulation &&
        (ci.COV_PROCESSING_STATE == CoverageState.aborted || ci.COV_PROCESSING_STATE == CoverageState.finished),
    )
  }

  get maxEndedCoverageIterationIdByMigId() {
    return this.endedCoverageIterations.reduce((acc, it) => {
      if (!acc[it.MIG_ID!] || acc[it.MIG_ID!] < it.COV_ID!) acc[it.MIG_ID!] = it.COV_ID!
      return acc
    }, {} as { [key: number]: number })
  }

  get coverageIterationsById() {
    return this.$store.myGetters.coverageIterationsById
  }

  get missionPlanTemplates() {
    return this.missionGlobals
      .reduce((list, m) => {
        if (isAloDbMissionGlobalCoverage(m)) {
          const maxCovId = this.maxEndedCoverageIterationIdByMigId[m.MIG_ID!]
          const covIteration =
            this.coverageIterationsById[(m.config?.templateSimId ?? 0) > 0 ? m.config!.templateSimId! : maxCovId]
          if (covIteration?.resultMipJson) {
            Object.keys(covIteration.resultMipJson)?.forEach(k => {
              list.push({
                id: `${m.MIG_ID!}_${k}`,
                libelle: `${m.MIG_LIBELLE} #${k}`,
                config: covIteration.resultMipJson![k],
              })
            })
          }
        } else {
          const maxVimId = Math.max(...m.misIdArray, -1)
          list.push({
            id: m.MIG_ID!.toString(),
            libelle: m.MIG_LIBELLE,
            config:
              (m.config?.templateSimId ?? 0) > 0
                ? this.missionVirtualsById[m.config!.templateSimId!]?.param ?? m.config
                : this.missionVirtualsById[maxVimId]?.param ?? m.config,
          })
        }
        return list
      }, [] as Array<{ id: string; libelle: string | null; config: ISmartSimulation }>)
      .filter(it => (it.config?.mission_plan?.steps?.length ?? 0) > 0)
  }

  loadFromTemplate() {
    if (this.templateId) {
      //Reset le mission plan en premier lieu
      this.plan = MissionPlanUiState.getDefaultMissionPlan()
      //@ts-ignore
      if (this.$refs.editPlan) this.$refs.editPlan.reset()

      //Charge le nouveau mission plan apres
      setTimeout(() => {
        const templateConfig = this.missionPlanTemplates.find(m => m.id == this.templateId)
        if (templateConfig) {
          this.plan = cloneDeep(templateConfig.config!.mission_plan)
          this.plan.gli_msn = this.mission.misIdx!
          this.plan.gli_key = this.mission.gliKey!
          //@ts-ignore
          if (this.$refs.editPlan) this.$refs.editPlan.reset()
        }
        this.templateId = null
      }, 500)
    }
  }

  async saveAndPublishMissionPlan() {
    //@ts-ignore
    if (this.config.enableMissionPlan && this.$refs.editPlan && !this.$refs.editPlan.canCloseWithoutWarning) {
      const response = await this.$confirm(this.$t('Pilot.MissionPlan.AlertSaveCurStep').toString(), {
        icon: 'mdi-alert',
        title: this.$t('Pilot.MissionPlan.AlertCurStepTitle').toString(),
      })
      if (response) {
        await this.doSaveAndPublishMissionPlan()
      }
    } else {
      await this.doSaveAndPublishMissionPlan()
    }
  }

  async doSaveAndPublishMissionPlan() {
    //mise à jour des gli_msn sur le mission plan
    //@ts-ignore
    if (this.$refs.editPlan) this.$refs.editPlan.updateWaypoint()

    this.plan.gli_msn = this.mission.misIdx!
    this.plan.gli_key = this.mission.gliKey!
    this.plan.dat_pub = new Date().toUTCString()
    const mis = await this.$store.myActions.MISSION_PLAN_SAVE_REQUEST(
      new AloMissionPlan({
        ...this.stagingMissionPlan,
        misId: this.mission.misId,
        detailLoaded: true,
        json: JSON.stringify(this.plan),
      } as IAloMissionPlanConstParam),
    )
    await this.$store.myActions.MISSION_PLAN_PUBLISH_REQUEST((mis as AloMissionPlan).id)
    await this.$store.myActions.MISSION_IRIS_MISSION_PLAN_REQUEST(this.mission.misId!)
  }

  saveAsTemplate() {
    //@ts-ignore
    if (this.$refs.editPlan) this.$refs.editPlan.updateWaypoint()
    this.template_name = this.mission.misLibelle!
    this.showSaveAsTemplate = true
  }

  async saveTemplate() {
    await this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    let template = this.$store.myGetters.missionGlobals.find(
      m => m.MIG_KEY == `tplt_${this.slugify(this.template_name)}`,
    )

    if (template && !isAloDbMissionGlobalSimulation(template)) {
      this.$confirm(this.$t('Pilot.MissionPlan.TemplateExistBadTypeAlert').toString(), {
        title: this.$t('Admin.Warning'),
        color: 'error',
      } as VuetifyConfirmObject)
    } else {
      if (template) {
        const answer = await this.$confirm(this.$t('Pilot.MissionPlan.TemplateExistAlert').toString(), {
          title: this.$t('Admin.Warning'),
          color: 'warning',
        } as VuetifyConfirmObject)
        if (!answer) return
      }

      if (!template) {
        //@ts-ignore
        template = new AloDbMissionGlobal({
          ENS_ID: this.$store.myGetters.userProfile.ensId,
          MIG_TYP: MissionGlobalType.SIMULATION,
          MIG_LIBELLE: this.template_name,
          MIG_KEY: `tplt_${this.slugify(this.template_name)}`,
        })

        template.config = getDefaultSmartSimulation()
      }

      ;(template!.config! as ISmartSimulation).mission_plan = this.plan // MissionPlanUiState.parseMissionPlan(JSON.stringify(this.plan))
      template.config!.templateSimId = null
      this.$store.commit(SIMULATION_SYNC_MISSSIONPLAN_SENSOR, template)

      const result = await apiAdminMissionGlobal.saveMissionGlobal(template)
      if (result.data.resultCode == ApiResultCode.Ok) {
        const missionGlobal = result.data.data as AloDbMissionGlobal
        //on force le rechargement de la liste des mission global
        await this.$store.myActions.MISSIONGLOBAL_SELECT_DETAIL_REQUEST(missionGlobal.MIG_ID!)
      }
    }
    this.showSaveAsTemplate = false
  }

  reloadFromIris() {
    return this.$store.myActions.MISSION_IRIS_MISSION_PLAN_REQUEST(this.mission.misId!).then(it => {
      this.plan = MissionPlanUiState.parseMissionPlan(JSON.stringify(it))
      //@ts-ignore
      if (this.$refs.editPlan) this.$refs.editPlan.reset()
    })
  }

  beforeDestroy() {
    //@ts-ignore
    this.plan = MissionPlanUiState.parseMissionPlan(JSON.stringify(this.originalIrisMissionPlan ?? '{}'), this.mission)
  }

  get showReloadFromIris() {
    return !deepEqual(this.originalIrisMissionPlan, this.plan)
  }

  get stagingMissionPlan() {
    return this.mission.missionPlanStaging
  }

  get stagingMissionPlanLoaded() {
    return this.mission._missionPlanLoaded
  }

  get loading() {
    return (
      this.$store.myGetters.missionPlanStagingLoading ||
      this.$store.myGetters.missionPlanConfigLoading ||
      this.$store.myGetters.missionPlanIrisLoading
    )
  }

  get status() {
    return this.$store.myGetters.missionStatus
  }

  get accessConfigMissionPlan() {
    return this.mission.security[SecurityItemsKeys.PILOT_DETAIL_MISSION_PLANNING]
  }

  get originalIrisMissionPlan() {
    return this.$store.myGetters.originalIrisMissionPlan[this.mission.misId!]
  }

  created() {
    this.$store.myActions.MISSIONVIRTUAL_ENSURE_LIST()
    this.$store.myActions.COVERAGEITERATION_ENSURE_LIST()
    this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    this.$store.myActions.MISSIONPLANTEMPLATE_ENSURE_LIST()
    if (this.mission.misId != null) {
      this.$store.myActions.MISSION_ENSURE_MISSION_PLAN(this.mission.misId!)
      if (this.accessConfigMissionPlan.enable) {
        this.$store.myActions.MISSION_IRIS_MISSION_PLAN_REQUEST(this.mission.misId)
        this.$store.myActions.MISSION_IRIS_MISSION_PLAN_CONFIG_REQUEST(this.mission.misId).then(it => {
          this.loadConfig(this.config, this.modifiedMissionPlanConfig)
          this.reloadFromIris()
        })
      }
    }
  }

  mounted() {}

  get originalMissionPlanConfig() {
    return this.$store.myGetters.originalMissionPlanConfigs[this.mission.misId!]
  }

  get modifiedMissionPlanConfig() {
    return this.$store.myGetters.modifiedMissionPlanConfigs[this.mission.misId!]
  }

  @Watch('tryClose')
  onTryClose() {
    //@ts-ignore
    if (this.config.enableMissionPlan && this.$refs.editPlan && !this.$refs.editPlan.canCloseWithoutWarning) {
      this.$confirm(this.$t('Pilot.MissionPlan.AlertCurStep').toString(), {
        icon: 'mdi-alert',
        title: this.$t('Pilot.MissionPlan.AlertCurStepTitle').toString(),
      }).then(response => {
        if (response) {
          this.close()
        }
      })
    } else {
      this.close()
    }
  }

  close() {
    const part = this.uiid.split('-')
    //console.log({cmp:part[0], isleft:this.isleft,id:Number.parseInt(part[1])})
    this.$store.myActions.MISSION_CLOSE_TAB({ cmp: part[0], isleft: this.isleft, id: Number.parseInt(part[1]) })
  }

  @Watch('mission')
  onMissionChanged(newValue: any) {
    if (newValue.misId != null) {
      this.$store.myActions.MISSION_IRIS_MISSION_PLAN_CONFIG_REQUEST(newValue.misId)
      this.reloadFromIris() // this.$store.myActions.MISSION_IRIS_MISSION_PLAN_REQUEST(newValue.misId);
    }
  }

  @Watch('modifiedMissionPlanConfig')
  onModifiedMissionPlanChanged(
    newConfig: IrisConfigContainer<IMissionPlanConfig>,
    oldConfig: IrisConfigContainer<IMissionPlanConfig>,
  ) {
    this.loadConfig(this.config, newConfig)
  }

  @Watch('config', { deep: true })
  onConfigChanged(newConfig: any) {
    this.validateConfig()
  }

  loadConfig(target: any, config: IrisConfigContainer<IMissionPlanConfig>) {
    if (config) {
      target.enableMissionPlan = config.mod_settings.EnabledMOD['module-MissionPlan']
      //target.enableCorrected =  config.mod_settings.MissionPlan_drift_corrected &&  config.mod_settings.MissionPlan_drift_corrected.enable
      //target.correctedFactor =  config.mod_settings.MissionPlan_drift_corrected?config.mod_settings.MissionPlan_drift_corrected.factor:0
      target.enableCorrected = config.mod_settings?.MissionPlan_current_correction?.enable ?? false
      target.mode = config.mod_settings?.MissionPlan?.current_mode
      target.lookahead = config.mod_settings?.MissionPlan?.lookahead ?? 1
      target.enablePayload = config.mod_settings?.MissionPlan_payload?.enable ?? false
    }
  }

  validateConfig() {
    this.$store.myActions.MISSION_UPDATE_MODIFIED_MISSION_PLAN_CONFIG({
      itemId: this.mission.misId!,
      newProperties: {
        mod_settings: {
          EnabledMOD: {
            'module-MissionPlan': this.config.enableMissionPlan,
          },
          /*MissionPlan_drift_corrected:{
              'enable':  this.config.enableCorrected,
              'factor': this.config.correctedFactor
            }*/
          MissionPlan_current_correction: {
            enable: this.config.enableCorrected,
          },
          MissionPlan_payload: {
            enable: this.config.enablePayload,
          },
          MissionPlan: {
            current_mode: this.config.mode,
            lookahead: this.config.lookahead,
          },
        },
      },
    })
  }

  get canSimulate() {
    //@ts-ignore
    return !!this.mission.yoArray?.at(-1)
  }

  async runEndMissionSimulation() {
    this.executing = true
    //Sauvrgarde avant le run
    try {
      await this.saveAndPublishMissionPlan()
      //@ts-ignore
      const lastYo = this.mission.yoArray?.at(-1)

      //TODO REPLAC MUT_ID By MUT_KEY
      const capteur = extractDistinctProp(this.mission.mesureTypeExArray, m => m?.UMT_KEY ?? '')

      //preparation des données d'entrée
      //@ts-ignore
      const data = getDefaultSmartSimulation({
        mission_start_date: `${(lastYo?.yoGpsDatTime ?? new Date()).toISOString().split('.')[0]}Z`, //`2022-10-01T12:00:00Z`,//`${new Date().toISOString().split('.')[0]}Z`,//`2023-10-01T12:00:00Z`
        enable_science_files: true,
        current_cycle: lastYo?.yosCycle ?? 1,
        wpt_init: [lastYo?.yoGpsLat ?? 0, lastYo?.yoGpsLon ?? 0],
        //@ts-ignore
        mission_plan: cloneDeep(this.plan),
        gliders_config: [
          //@ts-ignore
          getDefaultGliderConfig({
            libelle: this.mission.gliKey,
            payload: capteur ?? undefined,
            start_energy: lastYo?.batteries ?? undefined,
          }),
        ],
      })

      data.mission_plan.payload = capteur?.map((s, idx) => ({ id: idx + 1, snr_label: s })) ?? []
      data.mission_plan.prf_sci = [
        {
          id: 1,
          prf_label: 'default',
          sensors: data.mission_plan.payload.reduce((s, p) => {
            s[p.id] = [1, '111', 1]
            return s
          }, {} as { [key: number]: [number, string, number] }),
        },
      ]
      //@ts-ignore
      data.mission_plan.steps.forEach(s => (s.prfSci_id = data.mission_plan.payload.length > 0 ? 1 : null))

      //s'assure du bon format des nav : le plan relu d'IRIS (format glider) n'a pas zs → crash du simulateur
      data.mission_plan.prf_nav = data.mission_plan.prf_nav.map(p => ({
        ...MissionPlanUiState.getDefaultProfil(),
        ...p,
        current_correction: this.config.enableCorrected,
        radio: false,
        flasher: false,
        navigation_mode: this.config.mode == 'heading' ? 'heading' : 'waypoint',
      }))

      const errors = isReadyForSimulation(data)
      if (!errors?.length) {
        this.mission.vimDatexec = new Date()
        await this.$store.myActions.MISSION_RUN_END_SIMULATION_REQUEST({ misId: this.mission.misId!, data })
        //Pass à true les toggle de fin de simulation des cartes
        this.missionUiState.showRemainingNavigation = true
      } else {
        this.$confirm(`<ul><li>${errors.map(e => this.$t(`Simulation.Check.${e}`)).join('</li><li>')}</li></ul>`, {
          title: this.$t('Simulation.Check.Title'),
          buttonTrueText: 'Ok',
          buttonFalseText: '',
        } as VuetifyConfirmObject)
      }
      // const mapsTab = [...this.currentDetailMission.tabsleft.tabs.filter(t => t.cmp == 'MissionDetailMap'),...this.currentDetailMission.tabsright.tabs.filter(t => t.cmp == 'MissionDetailMap')].filter(c => !!c)
      // mapsTab.forEach(c => {
      //   const mapState = this.$store.myGetters.uistatebyuiid(`${c.cmp}-${c.id}`)  as MapUiState
      //   mapState.showEndMissionSimulation  = true
      // })
    } finally {
      this.executing = false
    }
  }

  async stopSimulation() {
    this.executing = true
    try {
      await apiAdminMissionVirtual.updateStatus(this.mission.misId!, SimulationStatus.aborted)
      this.mission.vimStatus = SimulationStatus.aborted
    } finally {
      this.executing = false
    }
  }

  saveConfig() {
    //@ts-ignore
    if (this.config.enableMissionPlan && this.$refs.editPlan && !this.$refs.editPlan.canCloseWithoutWarning) {
      this.$confirm(this.$t('Pilot.MissionPlan.AlertSaveCurStep').toString(), {
        icon: 'mdi-alert',
        title: this.$t('Pilot.MissionPlan.AlertCurStepTitle').toString(),
      }).then(response => {
        if (response) {
          this.validateConfig()
          this.$store.myActions.MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_REQUEST(this.mission.misId!)
        }
      })
    } else {
      this.validateConfig()
      this.$store.myActions.MISSION_IRIS_MISSION_PLAN_CONFIG_SAVE_REQUEST(this.mission.misId!)
    }
  }

  restoreConfig() {
    this.$store.myActions.MISSION_CANCEL_MODIFIED_MISSION_PLAN_CONFIG(this.mission.misId!)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading,
.body-2 {
  font-weight: bold;
}

.btnup {
  position: absolute;
  top: -6px;
  right: -7px;
}
.btnup:hover {
  position: absolute;
}
.btndown {
  position: absolute;
  bottom: -6px;
  right: -7px;
}
.btndown:hover {
  position: absolute;
}

.flex-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.position {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 31px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.disable {
  overflow: hidden !important;
  position: relative;
}

.disable::before {
  position: absolute;
  content: '';
  left: 0px;
  right: 0px;
  top: 0px;
  height: 8000%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
